import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import FormGroup from 'Components/FormGroup/FormGroup';
import ReviewRoundReports from '../containers/ReviewRoundReports';
import { TYPE_EXTERNAL } from 'Constants';
import SubmissionInvitationSend from 'Layouts/SubmissionManagement/containers/SubmissionInvitationSend';

export default class SubmissionExternalList extends PureComponent {
    /**
     * @type {Object}
     */
    static propTypes = {
        roundId: PropTypes.number.isRequired,
        submission: PropTypes.object.isRequired,
        isReviewFinished: PropTypes.bool
    };

    static filter = {
        where: { type: TYPE_EXTERNAL },
    };

    render() {
        const { roundId, submission, isReviewFinished } = this.props;

        return (
            <div>
                <FormGroup
                    title="form_groups.external_overview"
                    addtionalTitle={ !isReviewFinished && <SubmissionInvitationSend submission={submission}/>}
                    customTitleClass='external-reviewers-title-wrapper'
                >
                    <ReviewRoundReports round={roundId} customFilter={this.constructor.filter} />
                </FormGroup>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/SubmissionManagement/containers/SubmissionExternalList.jsx